import { withRouter } from 'utils/withRouter';
import SeparatorComponents from '../components';


export default withRouter(SeparatorComponents);
